export function updateAccount(state, { account }) {
  state.account = account;
}

export function updateSelectedAccount(state, { selectedAccount }) {
  state.selectedAccount = selectedAccount;
}

export function updateAccounts(state, { accounts }) {
  state.accounts = accounts;
}

export function setAllTransactions(state, { transactions }) {
  state.transactions = transactions;
}

export function updateFilterParams(state, { filterParams }) {
  state.filterParams = filterParams;
}
